export default function() {

  let optimisticProgressTimer = null;

  const stopOptimisticProgress = () => {
    if (optimisticProgressTimer) {
      clearInterval(optimisticProgressTimer);
      optimisticProgressTimer = null;
    }
  };

  const startOptimisticProgress = () => {
    stopOptimisticProgress();

    optimisticProgressTimer = setInterval(function() {
      const bar = $('.updating-progress .bar');
      if (bar.length === 0) {
        return;
      }

      const currentPercent = parseFloat(bar.attr('data-percent') || '0');
      if (Number.isNaN(currentPercent) || currentPercent >= 98) {
        return;
      }

      const nextPercent = Math.min(currentPercent + 0.2, 98);
      bar.attr('data-percent', nextPercent.toFixed(2));
      bar.css('width', nextPercent.toFixed(2) + '%');
      $('.percent-updated').empty().append('(' + Math.round(nextPercent) + '%)');
    }, 200);
  };

  // Start status poll
  const surveyProcessingPoll = () => {

    // Get generating message on page
    let isGenerating = $('.setting-up-survey');

    let status = isGenerating.data('survey-status');
    
    // Only continue if status indicator present (if should poll for recs is true)
    if (isGenerating.length !== 0) {

      // Set url to get data
      let accountUrl = isGenerating.data('account-url');
      let surveySlug = isGenerating.data('slug');
      let url = '/' + accountUrl + '/surveys/' + surveySlug + '/poll_setup.js';

      // Execute ajax request (using js erb template to render content so can control profile styling more easily)
      // Must specify '.js' otherwise processes as JSON
      $.ajax({
        type: "POST",
        dataType: "script",
        timeout: 3000,
        url: url,
        complete() {
          startOptimisticProgress();
          setTimeout(function() { surveyProcessingPoll() }, 2000);
        }
      });
    } else {
      stopOptimisticProgress();
    }
  };

  // Poll server for status of mapped items, if generating message present
  if ($('.setting-up-survey[data-should-poll=true]').length !== 0) { surveyProcessingPoll(); }

}
